import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description DataAnalyst icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { DataAnalyst } from '@sravni/design-system-icons'
 *
 * <DataAnalyst />
 * ```
 */
var DataAnalyst = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "DataAnalyst", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.4 6.667a.329.329 0 1 0 0 0", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.4 3.142a.313.313 0 1 0-.004-.627.313.313 0 0 0 .003.627ZM18.22 6.337a.312.312 0 1 0-.624 0 .312.312 0 0 0 .624 0Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.736 17.5v-15a7.5 7.5 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5Zm0 0a7.5 7.5 0 0 0 7.5-7.5h-7.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("circle", { cx: "17.986", cy: "6.25", r: ".75", fill: "currentColor" }),
    React.createElement("circle", { cx: "14.486", cy: "2.75", r: ".75", fill: "currentColor" }))); });

export { DataAnalyst };
//# sourceMappingURL=DataAnalyst.js.map
